module.exports = {

    methods:{

        /**
         * Return the data of the user, with the imagen uploaded if exists.
         */
        getUserData(){
            // Create a form date.
            var data = new FormData();

            // If there are attached pictures,
            // We add the files to the form.
            if (this.hasAttachedPicture()) {
                var files = this.$children[0].$refs.avatar.files;
                data.append('avatar', files[0]);
            }

            // If we are updating a user,
            // then we'll add the PUT method to the form data.
            if (this.userExists()) {
                data.append('_method', 'PUT');
                data.append('id', this.user.id);
            }

            // Password
            var password = this.user.password ? this.user.password : '';
            var password_confirmation = this.user.password_confirmation ? this.user.password_confirmation : '';
            data.append('password', password);
            data.append('password_confirmation', password_confirmation);

            // Append other fields.
            data.append('name', this.user.name);
            data.append('last', this.user.last);
            data.append('email', this.user.email);
            data.append('phone_number', this.user.phone_number);
            data.append('notes', this.user.notes);
            data.append('roles', JSON.stringify(this.user.roles));
            return data;
        },

        userExists(){
            return !!this.user.id;
        },

        hasAttachedPicture(){
            return this.$children[0].$refs.avatar.files.length;
        }
    },

}
